export default {
  path: '/product_statuses',
  name: 'product_statuses',
  component: () => import('../components/productstatus/Layout'),
  redirect: { name: 'ProductStatusList' },
  meta: {
    breadcrumb: 'qualitycheck.product.status',
  },
  children: [
    {
      name: 'ProductStatusList',
      path: '',
      component: () => import('../views/productstatus/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProductStatusCreate',
      path: 'new',
      component: () => import('../views/productstatus/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProductStatusUpdate',
      path: ':id/edit',
      component: () => import('../views/productstatus/Update'),
      meta: {
        breadcrumb: 'qualitycheck.product.statu',
      },
    },
    {
      name: 'ProductStatusShow',
      path: ':id',
      component: () => import('../views/productstatus/Show'),
      meta: {
        breadcrumb: 'qualitycheck.product.statu',
      },
    }
  ]
};
